export const buildPersistedProgressiveProfileOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!data) {
        return {
            firstName: null,
            lastName: null,
            email: null,
            companyName: null,
            jobTitle: null,
            phoneNumber: null,
            privacyConsentAccepted: false,
        };
    }
    return {
        firstName: (_a = data.firstName) !== null && _a !== void 0 ? _a : null,
        lastName: (_b = data.lastName) !== null && _b !== void 0 ? _b : null,
        email: (_c = data.email) !== null && _c !== void 0 ? _c : null,
        companyName: (_d = data.companyName) !== null && _d !== void 0 ? _d : null,
        jobTitle: (_e = data.jobTitle) !== null && _e !== void 0 ? _e : null,
        phoneNumber: (_f = data.phoneNumber) !== null && _f !== void 0 ? _f : null,
        privacyConsentAccepted: (_g = data.privacyConsentAccepted) !== null && _g !== void 0 ? _g : false,
    };
};
